// pages/InsertBlogLink.js
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { supabase } from '../lib/supabaseClient';
import Swal from 'sweetalert2';

export default function InsertBlogLink() {
  const [outlineOptions, setOutlineOptions] = useState([]);
  const [selectedOutline, setSelectedOutline] = useState(null);
  const [blogUrl, setBlogUrl] = useState('');
  const [status, setStatus] = useState('');

  // 🔄 Fetch all outline options
  useEffect(() => {
    const fetchOutlines = async () => {
      const { data, error } = await supabase
        .from('topics')
        .select(`
          id,
          name,
          blog_url,
          parent:parent_id ( module_code )
        `)
        .eq('level', 3)
        .order('name');

      if (error) {
        console.error('Error fetching outlines:', error);
        setStatus('❌ Error loading outlines.');
        return;
      }

      const options = data.map((outline) => ({
        value: outline.id,
        label: `${outline.parent?.module_code || '❓'} - ${outline.name}`,
        blog_url: outline.blog_url || '',
      }));

      setOutlineOptions(options);
    };

    fetchOutlines();
  }, []);

  // 🎯 Update blog URL field when outline is selected
  useEffect(() => {
    if (selectedOutline) {
      setBlogUrl(selectedOutline.blog_url || '');
    } else {
      setBlogUrl('');
    }
  }, [selectedOutline]);

  // 💾 Save blog URL to Supabase
  const handleSave = async () => {
    if (!selectedOutline || !blogUrl.trim()) {
      setStatus('❌ Please select an outline and enter a blog URL.');
      return;
    }

    const { error } = await supabase
      .from('topics')
      .update({ blog_url: blogUrl.trim() })
      .eq('id', selectedOutline.value);

    if (error) {
      console.error('Error saving blog URL:', error);
      Swal.fire('❌ Error', 'Failed to save blog URL.', 'error');
    } else {
      Swal.fire('✅ Success', 'Blog URL updated successfully!', 'success');
      setStatus('✅ Blog link saved.');
    }
  };

  return (
    <div className="max-w-xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-6 text-indigo-700 text-center">📎 Insert Blog Link for Outline</h2>

      <div className="mb-4">
        <label className="block mb-1 font-medium text-gray-700">Select Outline:</label>
        <Select
          options={outlineOptions}
          value={selectedOutline}
          onChange={setSelectedOutline}
          placeholder="Search outline..."
        />
      </div>

      <div className="mb-4">
        <label className="block mb-1 font-medium text-gray-700">Blog URL:</label>
        <input
          type="text"
          className="w-full border px-3 py-2 rounded"
          placeholder="https://www.monetarymix.com/blog/..."
          value={blogUrl}
          onChange={(e) => setBlogUrl(e.target.value)}
        />
      </div>

      <button
        onClick={handleSave}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
      >
        💾 Save Blog Link
      </button>

      {status && <div className="mt-4 text-sm text-indigo-700">{status}</div>}
    </div>
  );
}
